module.exports = __webpack_public_path__ + "img/hilight-3.a527680e.png";